import { render, staticRenderFns } from "./FeesInsightPopup.vue?vue&type=template&id=36bcd2f3&scoped=true"
import script from "./FeesInsightPopup.vue?vue&type=script&lang=js"
export * from "./FeesInsightPopup.vue?vue&type=script&lang=js"
import style0 from "./FeesInsightPopup.vue?vue&type=style&index=0&id=36bcd2f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bcd2f3",
  null
  
)

export default component.exports